import React, {useCallback} from 'react';
import cn from 'classnames';

import {isProductSearchHitModel} from 'coreClasses/search/ProductSearchHitModel';
import Skeleton from 'coreComponents/Skeleton';

import {useGeneralProvider} from 'brandComponents/_app-config/GeneralProvider';
import ProductMedia from 'brandComponents/product/ProductMedia';
import {EProductMediaType} from 'brandComponents/product/ProductMedia';

import {useProductHitContext} from '../../ProductHitContext';

import {IProductHitMedia} from './IProductHitMedia';

import styles from './ProductHitMedia.module.scss';

const ProductHitMedia = ({
	classNames,
	mediaType,
	onClick,
	carouselConfig,
	ratio,
	imageSettings,
	pushDataLayerClickEvent = true,
	renderPicture,
	source,
	sourceSpecification,
	isLink = true,
	showPlaceholder,
	priority,
}: IProductHitMedia) => {
	const {product, position, dataLayerEventOnClick} = useProductHitContext();
	const isProductSearchHit = isProductSearchHitModel(product);
	const {managerRepository} = useGeneralProvider();

	const handleClick = useCallback(() => {
		onClick?.();

		if (!onClick) {
			managerRepository.getFlyoutsMgr().closeAllFlyouts();
		}

		if (!isProductSearchHit && pushDataLayerClickEvent) {
			dataLayerEventOnClick(product, position, source, sourceSpecification);
		}
	}, [onClick, isProductSearchHit, product, source, sourceSpecification]);

	return (
		<div className={cn(styles['product-hit__media'], 'product-hit__media', classNames)}>
			{product && (
				<ProductMedia
					carouselConfig={carouselConfig}
					mediaType={mediaType || EProductMediaType.CAROUSEL}
					product={product}
					onClick={handleClick}
					ratio={ratio}
					imageSettings={imageSettings}
					renderPicture={renderPicture}
					isLink={isLink}
					showPlaceholder={showPlaceholder}
					priority={priority}
				/>
			)}

			{!product && <Skeleton classNames={styles['product-hit__media__skeleton']} />}
		</div>
	);
};

export default ProductHitMedia;
